import axios from 'axios';
import { STORE_BASE_URL } from '../BaseURL';
import getHeaders from '../../constants/headers';

export const addItemToCart = (id, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/cart', // for android use
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addMoreItemToOrder = (id, storeId, orderId,data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId + "/order-item",
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const editMoreItemToOrder = (id, storeId, orderId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/order/' +
      orderId +
      '/order-item',
    headers:  getHeaders(),
    data: JSON.stringify(data),
  });
};

export const editMoreItemToOrderAdmin = (id, storeId, orderId, data) => {
  return axios({
    method: "put",
    url:
      STORE_BASE_URL +
      "/store/api/secure/v1/store/" +
      storeId +
      "/store-customer/" +
      id +
      "/order/" +
      orderId +
      "/order-item-by-admin",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const editMoreItemToOrderB2B = (id, storeId, orderId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/challan/' +
      orderId +
      '/challan-item',
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const addMoreItemToOrderB2BOrder = (id, storeId, challanId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/b2b/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/challan/' +
      challanId + "/challan-item",
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};